import { r as registerInstance, h, a as Host, g as getElement } from './index-e3e7270f.js';
import { e as check, b as alert_exclamation_circle, p as preview_on, k as preview_off, l as close } from './icons-0c9227e3.js';
import { u as uuidv4, e as en } from './helpers-7bea9f35.js';

const translations = {
    SHOW: {
        sv: 'Visa',
        en: 'Show',
        da: 'At vise',
        fi: 'Näytä',
        no: 'Vise',
    },
    HIDE: {
        sv: 'Dölj',
        en: 'Hide',
        da: 'Skjule',
        fi: 'Piilottaa',
        no: 'Gjemme seg',
    },
    CLEAR: {
        sv: 'Rensa',
        en: 'Clear',
        da: 'Klar',
        fi: 'Asia selvä',
        no: 'Klar',
    },
};

const pnInputCss = "pn-input{display:inline-flex;flex-direction:column}pn-input .pn-input-label{margin-bottom:0.5em;color:#5e554a;display:flex;justify-content:space-between;align-items:flex-end;cursor:pointer;transition:color 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86)}pn-input .pn-input-label>span{font-size:0.875em}pn-input .pn-input-label>span:nth-child(2){flex-shrink:0;padding-left:0.5em}pn-input .pn-input{position:relative}pn-input .pn-input>input{padding:0.75em;font-size:1em;font-weight:500;-webkit-font-smoothing:antialiased;outline:none;border-radius:0.5em;border:0.0625em solid #5e554a;transition:box-shadow 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86), border 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86);color:#2d2013;width:100%;background-color:#ffffff}pn-input .pn-input>input[data-offset]{padding-right:3em}pn-input .pn-input>input::placeholder{color:#969087;font-weight:normal}pn-input .pn-input>input:focus{border-color:#005d92;box-shadow:0 0 0 0.125em #ffffff, 0 0 0 0.25em #005d92}pn-input .pn-input>input:hover{border-color:#00a0d6}pn-input .pn-input>input:read-only{border-color:transparent}pn-input .pn-input>input:disabled{background-color:#f3f2f2;border-color:transparent}pn-input .pn-input>input::-webkit-calendar-picker-indicator{visibility:hidden;display:none}pn-input .pn-input>input::-webkit-input-placeholder{visibility:hidden}pn-input .pn-input>input::-webkit-textfield-decoration-container,pn-input .pn-input>input::-webkit-calendar-picker-indicator,pn-input .pn-input>input::-webkit-search-cancel-button,pn-input .pn-input>input::-webkit-inner-spin-button,pn-input .pn-input>input::-webkit-outer-spin-button,pn-input .pn-input>input::-webkit-search-decoration{-webkit-appearance:none;-moz-appearance:none;appearance:none}pn-input .pn-input>input[type=number]{appearance:textfield}pn-input .pn-input>pn-icon,pn-input .pn-input>pn-button{position:absolute;right:0.75em;top:50%;transform:translateY(-50%)}pn-input .pn-input-text{transition:transform 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86);margin:0.25em 0 0}pn-input .pn-input-text>span{display:block;font-size:0.75em;color:#5e554a}pn-input[data-error]>.pn-input-label{color:#a70707}pn-input[data-error]>.pn-input>input{border-color:#a70707}pn-input[data-error]>.pn-input>input:focus{border-color:#a70707;box-shadow:0 0 0 0.125em #ffffff, 0 0 0 0.25em #a70707}pn-input[data-error]>.pn-input>input:hover{border-color:#f06365}pn-input[data-error]>.pn-input-text[role=alert]>span{color:#a70707}pn-input[data-valid]>.pn-input-label{color:#005e41}pn-input[data-valid]>.pn-input>input{border-color:#005e41}pn-input[data-valid]>.pn-input>input:focus{border-color:#005e41;box-shadow:0 0 0 0.125em #ffffff, 0 0 0 0.25em #005e41}pn-input[data-valid]>.pn-input>input:hover{border-color:#5ec584}";
const PnInputStyle0 = pnInputCss;

const PnInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.inputTextId = `pn-input-text-${uuidv4()}`;
        this.showPassword = false;
        this.label = undefined;
        this.helpertext = undefined;
        this.inputid = `pn-input-${uuidv4()}`;
        this.value = '';
        this.language = undefined;
        this.type = 'text';
        this.name = undefined;
        this.placeholder = undefined;
        this.ariaLabel = undefined;
        this.ariaControls = undefined;
        this.autocomplete = undefined;
        this.maxlength = undefined;
        this.inputmode = undefined;
        this.list = undefined;
        this.pattern = undefined;
        this.min = undefined;
        this.max = undefined;
        this.step = undefined;
        this.disabled = false;
        this.required = false;
        this.readonly = false;
        this.valid = false;
        this.invalid = false;
        this.error = '';
    }
    togglePassword() {
        this.showPassword = !this.showPassword;
    }
    componentWillLoad() {
        const topbar = window.pnTopbar;
        if (this.language)
            return;
        if (topbar)
            this.init();
        else
            window.addEventListener('topbarLoaded', () => this.init());
    }
    init() {
        const topbar = window.pnTopbar;
        if (!topbar)
            return;
        this.language = topbar.language;
        topbar.onChangeLanguage = (language) => {
            this.language = language;
        };
    }
    setVal(e) {
        var _a;
        const target = (_a = e.composedPath) === null || _a === void 0 ? void 0 : _a.call(e)[0];
        this.value = target.value;
    }
    clearVal() {
        const inputClear = new InputEvent('input', { bubbles: true, data: '' });
        const input = this.hostElement.querySelector('input');
        this.value = '';
        input.focus();
        input.value = this.value;
        input.dispatchEvent(inputClear);
    }
    translate(prop) {
        var _a;
        return (_a = translations === null || translations === void 0 ? void 0 : translations[prop]) === null || _a === void 0 ? void 0 : _a[this.language || en];
    }
    getTextMessage() {
        var _a;
        if ((_a = this.error) === null || _a === void 0 ? void 0 : _a.length)
            return this.error;
        return this.helpertext;
    }
    getInputType() {
        const types = ['text', 'password', 'url', 'tel', 'search', 'number', 'email'];
        return types.includes(this.type) && !this.showPassword ? this.type : 'text';
    }
    isPassword() {
        if (this.disabled)
            return false;
        return this.type === 'password' || (this.type === 'text' && this.showPassword);
    }
    isSearch() {
        var _a;
        if (this.disabled)
            return false;
        return !!(this.type === 'search' && ((_a = this.value) === null || _a === void 0 ? void 0 : _a.length));
    }
    hasErrorMessage() {
        var _a;
        return ((_a = this.error) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
    hasError() {
        return this.hasErrorMessage() || this.invalid;
    }
    hasButton() {
        return this.isPassword() || this.isSearch();
    }
    hasOffset() {
        return this.hasButton() || this.hasError() || this.valid;
    }
    render() {
        return (h(Host, { key: 'aa5492095bba0c020ec50fcabb9b8828b2ec1d91', "data-valid": this.valid && !this.hasError(), "data-error": this.hasError() }, (this.label || this.maxlength >= 1) && (h("label", { htmlFor: this.inputid, class: "pn-input-label" }, this.label && h("span", null, this.label), this.maxlength >= 0 && h("span", null, `${this.value.length}/${this.maxlength}`))), h("div", { key: '12ef8f2beea83b6173d693c856b294586ee440f7', class: "pn-input" }, h("input", { key: '799ac9506d22d5d29377dbf26b16e92419f5c6ae', type: this.getInputType(), value: this.value, id: this.inputid, name: this.name, placeholder: this.placeholder, disabled: this.disabled, required: this.required, readonly: this.readonly, autocomplete: this.autocomplete, onInput: e => this.setVal(e), maxlength: this.maxlength, list: this.list, pattern: this.pattern, min: this.min, max: this.max, step: this.step, inputmode: this.inputmode, "aria-label": this.ariaLabel, "aria-describedby": !!this.getTextMessage() && this.inputTextId, "aria-controls": this.ariaControls, "data-offset": this.hasOffset() }), !this.hasButton() && this.valid && !this.hasError() && h("pn-icon", { symbol: check, color: "green700" }), !this.hasButton() && this.hasError() && (h("pn-icon", { symbol: alert_exclamation_circle, color: "warning" })), this.isPassword() && (h("pn-button", { type: "button", icon: this.showPassword ? preview_on : preview_off, "icon-only": true, small: true, appearance: "light", variant: "borderless", onClick: () => this.togglePassword() }, h("span", null, this.translate(this.showPassword ? 'HIDE' : 'SHOW')))), this.isSearch() && (h("pn-button", { type: "button", icon: close, "icon-only": true, small: true, appearance: "light", variant: "borderless", onClick: () => this.clearVal() }, h("span", null, this.translate('CLEAR'))))), !!this.getTextMessage() && (h("p", { class: "pn-input-text", id: this.inputTextId, role: this.hasErrorMessage() ? 'alert' : null }, h("span", null, this.getTextMessage())))));
    }
    get hostElement() { return getElement(this); }
};
PnInput.style = PnInputStyle0;

export { PnInput as pn_input };

//# sourceMappingURL=pn-input.entry.js.map